import { useQuery } from "@tanstack/react-query"
import { usePaginatedResource, useResourceItem, useCreateResource, useEditResource } from "./useCrudResource"
import {
  getVehicleDailyAudits,
  getVehicleDailyAudit,
  closeVehicleDailyAudit,
  reopenVehicleDailyAudit,
  getVehiclesByLastLocation,
} from "api/vehicleDailyAuditApi"

export const VEHICLE_DAILY_AUDIT_QUERY_KEY = "vehicle-daily-audits"

export const useVehicleDailyAudits = (params = {}, enabled = true) => {
  return usePaginatedResource(
    VEHICLE_DAILY_AUDIT_QUERY_KEY,
    getVehicleDailyAudits,
    params,
    enabled
  )
}

export const useVehicleDailyAudit = (id, enabled = true) => {
  return useResourceItem(VEHICLE_DAILY_AUDIT_QUERY_KEY, getVehicleDailyAudit, id, enabled)
}

export const useCloseVehicleDailyAudit = () => {
  return useCreateResource(closeVehicleDailyAudit, VEHICLE_DAILY_AUDIT_QUERY_KEY)
}

export const useReopenVehicleDailyAudit = () => {
  return useEditResource(reopenVehicleDailyAudit, VEHICLE_DAILY_AUDIT_QUERY_KEY)
}

export const useVehiclesByLastLocation = (locationId, enabled = true) => {
  return useQuery({
    queryKey: [VEHICLE_DAILY_AUDIT_QUERY_KEY, "vehicles-by-location", locationId],
    queryFn: () => getVehiclesByLastLocation(locationId),
    enabled: !!locationId && enabled,
  })
}
